// /admin/v1/diamonds/* — transaction ledger + manual grant/revoke.

import { list, post } from './client';
import type { ListResult } from './client';

export type DiamondReason =
  | 'topup'
  | 'generation'
  | 'admin_grant'
  | 'admin_revoke'
  | 'share_bonus'
  | 'invite_reward'
  | 'refund'
  | string;

export interface DiamondTransaction {
  id: string;
  user_id: string;
  delta: number;
  balance_after: number;
  reason: DiamondReason;
  ref_id?: string;
  app_id?: number;
  app_slug?: string;
  notes?: string;
  created_at: string;
}

export interface ListDiamondTxQuery {
  user_id?: string;
  app_id?: number;
  reason?: DiamondReason;
  /** `in` = positive delta (credits), `out` = negative delta (spends). */
  direction?: 'in' | 'out';
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export function listTransactions(
  q: ListDiamondTxQuery = {},
): Promise<ListResult<DiamondTransaction>> {
  return list<DiamondTransaction>('/admin/v1/diamonds/transactions', q);
}

export interface GrantRevokeInput {
  /** 归属 App — 后端要求 (钻石按 App 记账, binding:"required"). */
  app_id: number;
  amount: number;
  reason: string;
  notes?: string;
  idempotency_key?: string;
}

export function grant(userId: string, body: GrantRevokeInput): Promise<DiamondTransaction> {
  return post<DiamondTransaction>(`/admin/v1/diamonds/users/${userId}/grant`, body, {
    headers: body.idempotency_key
      ? { 'Idempotency-Key': body.idempotency_key }
      : undefined,
  });
}

export function revoke(userId: string, body: GrantRevokeInput): Promise<DiamondTransaction> {
  return post<DiamondTransaction>(`/admin/v1/diamonds/users/${userId}/revoke`, body, {
    headers: body.idempotency_key
      ? { 'Idempotency-Key': body.idempotency_key }
      : undefined,
  });
}
